var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckCircle = function SvgCheckCircle(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#68CA77",
    clipPath: "url(#checkCircle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.087 9.663 8.75 11.49l.01-.01 4.175-4.533 1.195 1.108-4.456 4.837c-.25.261-.576.402-.924.402s-.674-.14-.913-.39L5.88 10.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M1.848 10C1.848 5.5 5.5 1.848 10 1.848S18.152 5.5 18.152 10 14.5 18.152 10 18.152A8.155 8.155 0 0 1 1.848 10m1.63 0A6.527 6.527 0 0 0 10 16.522 6.527 6.527 0 0 0 16.522 10 6.527 6.527 0 0 0 10 3.478 6.527 6.527 0 0 0 3.478 10",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "checkCircle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.25 1.25h17.5v17.5H1.25z"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckCircle);
export default ForwardRef;